import styled from 'styled-components';

export const Form = styled.form`
  margin: 0;
  padding: 0;
`;

export const OpenCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px;
  border-radius: 10px;
  background: #f5f5f5;
  border: 1px solid #eae7e7;

  grid-column: span 2;

  @media only screen and (max-width: 500px) {
    grid-column: unset;
  }
`;
export const TitleCard = styled.label`
  font-size: 16px;
  color: #6e6e6e;
  font-weight: bold;
  padding-bottom: 4px;
`;
export const SubitleCard = styled.label`
  color: #aaaaaa;
  font-family: Roboto;
  font-weight: normal;
  font-size: 14px;
  word-break: break-all;

  & b {
    color: #6e6e6e;
  }
`;
export const ImageContent = styled.div`
  display: flex;
  width: 100%;
  gap: 14px;
  flex-wrap: wrap;

  & img {
    width: 60px;
    height: 60px;
    border-radius: 10px;
    border: 1px solid #eae7e7;
  }
`;

export const MapCard = styled.div`
  display: flex;
  border-radius: 10px;
  background: #f5f5f5;
  border: 1px solid #eae7e7;
  overflow: hidden;

  grid-column: span 2;

  @media only screen and (max-width: 500px) {
    grid-column: unset;
  }
`;
